module.exports = __webpack_public_path__ + "img/arrow-right.677d32cc.svg";